/** Постер слишком большой по размеру */
// import poster from './likes.png'
import React, { FC } from 'react'

import { AlphaVideo } from './AlphaVideo'
import videoCallAv1 from './likes_av1.mp4'
import videoCallHevc from './likes_hevc_alpha.mp4'

export const LikesVideo: FC = () => {
  return <AlphaVideo av1={videoCallAv1} hevc={videoCallHevc} />
}

export default LikesVideo
